import { mask } from 'vue-the-mask';
import { Constants } from './Constants.js';

export default {
	directives: {
		mask
	},
	data () {
		return {
			constants: Constants,
			MAX_UPDATE_DELAY_IN_SECONDS: 120,
			validationRules: {
				required: v => !!v || window.$vue.$t('common.validations.required_field'),
				requiredBoolean: v => !(!v && v !== false) || window.$vue.$t('common.validations.required_field'),
				requiredMultiple: v => !!(v && v.length) || window.$vue.$t('common.validations.required_field'),
				dnicif: v => !v || this.validateDNI(v) || this.validateCIF(v) || window.$vue.$t('common.validations.invalid_field'),
				email: v => !v || /.+@.+\..+/.test(v) || window.$vue.$t('common.validations.invalid_field')
			},
		}
	},
	methods: {
		validateDNI(value) {
			value = value ? value.toUpperCase() : null;

			var esValido = /^([0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]|[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET])$/.test(value);

			if (esValido === false) {
				return false;
			}

			var letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKET";

			var nie = value.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');

			var letra1 = value.substr(-1);
			var posicion = parseInt(nie.substr(0, 8)) % 23;
			var letra2 = letrasValidas.charAt(posicion);

			return letra1 === letra2;
		},
		validateCIF(value) {
			value = value ? value.toUpperCase() : null;

			var esValido = /^[A-Z]{1}[0-9]{7}[A-J0-9]{1}$/.test(value);

			if (esValido === false) {
				return false;
			}

			var letrasValidas = "JABCDEFGHI";

			var digitos = value.substr(1, value.length - 2);
			var letra = value.substr(0, 1);
			var control = value.substr(value.length - 1);
			var suma = 0;

			if (!letra.match(/[A-Z]/)) {
				return false;
			}

			for (var i = 0; i < digitos.length; i++) {
				var digito = parseInt(digitos[i]);

				if (isNaN(digito)) {
					return false;
				}

				if (i % 2 === 0) {
					digito *= 2;
					if (digito > 9) {
						digito = parseInt(digito / 10) + (digito % 10);
					}

					suma += digito;
				} else {
					suma += digito;
				}
			}

			suma %= 10;
			if (suma !== 0) {
				digito = 10 - suma;
			} else {
				digito = suma;
			}

			if (letra.match(/[ABEH]/)) {
				return String(digito) === control;
			}
			if (letra.match(/[NPQRSW]/)) {
				return letrasValidas[digito] === control;
			}

			return String(digito) === control || letrasValidas[digito] === control;
		},
		formatDate(value) {
			return !value ? '' : new Date(value).toLocaleDateString();
		},
		formatOnlyDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatFullDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			var result = new Date(value).toLocaleString([this.$i18n.locale, 'en'], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			return result.charAt(0).toUpperCase() + result.slice(1);
		},
		formatLongDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatShortDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit' });
		},
		formatLongDateTime(value, is24hours) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false : undefined });
		},
		formatShortDateTime(value, is24hours) {
			if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false : undefined });
		},
		formatTime(value, is24hours) {
			if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { hour: '2-digit', minute: '2-digit', hour12: is24hours ? false : undefined });
		},
		fixISODate(date) {
			if (!date) return null;
			return date.split('[')[0];
		},
		validateJson(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (e) {
				e;
			}
			return false;
		},
		getTimeWithZoneOffset (date) {
			if (!date) return null

			if (typeof date === 'number') {
				date = new Date(date); //la entrada son milisegundos
					}

			if (typeof date === 'string') {
				date = new Date(date.split('[')[0]); //la entrada son milisegundos
					}

					return date.toLocaleTimeString([this.$i18n.locale, "en"], { hour: '2-digit', minute: '2-digit', hour12: false });
		},
		needsUpdate(lastUpdate) {
			if (!lastUpdate) {
				return true;
			}

			//Obtenemos la diferencia en milisegundos
			var diff = new Date().getTime() - lastUpdate.getTime();

			//Convertimos la diferencia a segundos
			diff /= 1000;

			//Si la diferencia es mayor de MAX_UPDATE_DELAY_IN_SECONDS devolvemos true; si no, devolvemos false
			return diff > this.MAX_UPDATE_DELAY_IN_SECONDS;
		},
		st: function (key) {
			if (key && key.indexOf && key.indexOf(key) === 0) {
				return this.$t(key);
			}
			return key;
		},
		getAssessmentModules(modules) {
			let text = '';

			const m = modules.split(',').map(Number).sort();

			for (let i = 0; i < m.length; i++) {
				switch (m[i]) {
					case 1:
						text += this.$t('common.assessment.modules.1');
						break;
					case 2:
						text += this.$t('common.assessment.modules.2');
						break;
					case 3:
						text += this.$t('common.assessment.modules.3');
						break;
					case 4:
						text += this.$t('common.assessment.modules.4');
						break;
				}

				if (i < m.length - 1) {
					text += ', ';
				}
			}

			return text;
		},
		getAssessmentStatusColor(status) {
			let color = '';

			switch (status) {
				case this.constants.AS_PENDING_STATUS:
					color = '#21A6E7';
					break;
				case this.constants.AS_IN_PROGRESS_STATUS:
					color = '#FF9800';
					break;
				case this.constants.AS_FINISHED_STATUS:
					color = '#3BA70C';
					break;
			}

			return color;
		},
		getAssessmentStatusText(status) {
			let text = '';

			switch (status) {
				case this.constants.AS_PENDING_STATUS:
					text = this.$t('common.assessment.status.pending');
					break;
				case this.constants.AS_IN_PROGRESS_STATUS:
					text = this.$t('common.assessment.status.in_progress');
					break;
				case this.constants.AS_FINISHED_STATUS:
					text = this.$t('common.assessment.status.finished');
					break;
			}

			return text.toUpperCase();
		}
	}
}